/* tslint:disable */

declare var Object: any;
export interface QuestionSetInterface {
  "sfdcId"?: string;
  "Business_Unit__c"?: string;
  "Language__c"?: string;
  "Legacy_QuestionSetID__c"?: string;
  "Passing_Score__c"?: number;
  "Skill_Codes__c"?: string;
  "Status__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class QuestionSet implements QuestionSetInterface {
  "sfdcId": string;
  "Business_Unit__c": string;
  "Language__c": string;
  "Legacy_QuestionSetID__c": string;
  "Passing_Score__c": number;
  "Skill_Codes__c": string;
  "Status__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: QuestionSetInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `QuestionSet`.
   */
  public static getModelName() {
    return "QuestionSet";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of QuestionSet for dynamic purposes.
  **/
  public static factory(data: QuestionSetInterface): QuestionSet{
    return new QuestionSet(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'QuestionSet',
      plural: 'QuestionSets',
      path: 'QuestionSets',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Business_Unit__c": {
          name: 'Business_Unit__c',
          type: 'string'
        },
        "Language__c": {
          name: 'Language__c',
          type: 'string'
        },
        "Legacy_QuestionSetID__c": {
          name: 'Legacy_QuestionSetID__c',
          type: 'string'
        },
        "Passing_Score__c": {
          name: 'Passing_Score__c',
          type: 'number'
        },
        "Skill_Codes__c": {
          name: 'Skill_Codes__c',
          type: 'string'
        },
        "Status__c": {
          name: 'Status__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
